import {Toast} from 'primereact/toast'
import {RefObject} from 'react'

export const showCheckMarkToast = (toast: RefObject<Toast>): void =>
	toast?.current?.show({
		className: 'max-width-70 mt-7 checkmark-toast',
		closable: false,
		content: undefined,
		contentClassName: '',
		contentStyle: undefined,
		sticky: false,
		style: undefined,
		summary: undefined,
		severity: 'success',
		life: 1600
	})

export const showErrorToast = (toast: RefObject<Toast>, title: string, message: string): void =>
	toast?.current?.show({
		className: 'mt-7',
		closable: true,
		contentClassName: '',
		contentStyle: undefined,
		sticky: false,
		style: undefined,
		summary:  title,
		content: message,
		severity: 'error',
		life: 12000
	})
